"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CalendarDay = CalendarDay;
exports.enhance = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _get_date = _interopRequireDefault(require("date-fns/get_date"));

var _values = _interopRequireDefault(require("lodash/values"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _withProps = _interopRequireDefault(require("recompose/withProps"));

var _withHandlers = _interopRequireDefault(require("recompose/withHandlers"));

var _Button = _interopRequireDefault(require("./Button"));

var DateTypes = {
  PAST: 'past',
  TODAY: 'today',
  OPEN: 'open',
  CLOSED: 'closed',
  INVALID: 'invalid',
  SELECTED: 'selected'
};
var enhance = (0, _compose["default"])((0, _withProps["default"])(function (props) {
  return {
    type: (0, _pick["default"])(props, (0, _values["default"])(DateTypes))
  };
}), (0, _withHandlers["default"])({
  handleClick: function handleClick(_ref) {
    var date = _ref.date,
        type = _ref.type,
        onDateClick = _ref.onDateClick;
    return function () {
      return onDateClick({
        date: date,
        type: type,
        string: (0, _format["default"])(date, 'MM/DD/YYYY')
      });
    };
  }
}));
exports.enhance = enhance;

function CalendarDay(_ref2) {
  var className = _ref2.className,
      closed = _ref2.closed,
      date = _ref2.date,
      type = _ref2.type,
      notInCurrentMonth = _ref2.notInCurrentMonth,
      handleClick = _ref2.handleClick;
  return /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: (0, _classnames["default"])('calendar-day', type, className, {
      'next-month': notInCurrentMonth
    }),
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "date-text"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "date-number-text"
  }, (0, _get_date["default"])(date)), closed && /*#__PURE__*/_react["default"].createElement("div", {
    className: "state-text"
  }, "closed"))));
}

CalendarDay.propTypes = {
  date: _propTypes["default"].instanceOf(Date).isRequired,
  type: _propTypes["default"].object.isRequired,
  closed: _propTypes["default"].bool,
  notInCurrentMonth: _propTypes["default"].bool,
  handleClick: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string
};

var _default = enhance(CalendarDay);

exports["default"] = _default;